import React from 'react';
import './SaludoDelAlcalde.css';
import Alcaldesa from '../../Images/Alcalde.webp';

const SaludoDelAlcalde = () => (
  <section className="saludo-alcalde">
    <div className="overlay">
      <div className="card-saludo">
        {/* IMAGEN CENTRADA */}
        <div className="imagen-alcalde-centrada">
          <img
            src={Alcaldesa}
            alt="Sonia María Gómez Fernández — Alcaldesa de Escalonilla"
          />
        </div>

        {/* TÍTULO */}
        <h1 className="titulo-saludo">
          Bienvenidos al Ayuntamiento de Escalonilla
        </h1>

        {/* TEXTO */}
        <div className="texto-box">
          <p>Queridos vecinos,</p>
          <p>
            Es un honor dirigirme a vosotros como alcaldesa de nuestro querido
            municipio y daros la bienvenida a la página web del Ayuntamiento.
            Este espacio ha sido creado para acercar la administración a todos
            los ciudadanos, ofreciendo información útil, transparencia y
            herramientas para facilitar la comunicación con el consistorio.
          </p>
          <p>
            Nuestro compromiso es trabajar cada día para mejorar la calidad de
            vida en nuestro pueblo, impulsando el desarrollo, la seguridad y
            los servicios que todos merecemos. Aquí encontraréis noticias,
            trámites, actividades y todo lo necesario para estar informados
            sobre la gestión municipal.
          </p>
          <p>
            Os animo a utilizar esta plataforma y a participar activamente en
            la vida de nuestro municipio. Juntos, con vuestra colaboración,
            seguiremos construyendo un pueblo mejor.
          </p>
          <p>Recibid un cordial saludo.</p>

          <div className="firma">
            <h2>Sonia María Gómez Fernández</h2>
            <p>Alcaldesa de Escalonilla</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default SaludoDelAlcalde;
